import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/global.css'
import Vant from 'vant'
import 'vant/lib/index.css'
import ElementUI from 'element-ui'
import VueClipboard2 from 'vue-clipboard2'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
Vue.use(Vant)
Vue.use(ElementUI)
Vue.use(VueClipboard2)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
